import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const ProductPrice = ({ product }) => {
  // Variant 0: shows price in red color; Variant 1: shows ##% OFF
  const priceLineVariant = useSelector(
    (state) => state.experiment.priceLine?.variant_id === 1
  )
  const onSale = product.reg !== product.selling
  const savePercent = (
    ((product.reg - product.selling) / product.reg) *
    100
  ).toFixed(0)

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${product.reg}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.selling}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.reg}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }

  return (
    <div className="body-sm" {...globaleAttrs.container}>
      {IS_JEWLR() ? (
        <>
          {onSale ? (
            <>
              <p className="font-medium">
                <span className="sr-only">Current price: </span>
                <span
                  className={cn(
                    "text-12 tablet:text-13 widescreen:text-14",
                    !priceLineVariant && "text-sale"
                  )}
                >
                  from
                </span>{" "}
                <span
                  className={cn(!priceLineVariant && "text-sale")}
                  data-cy={`collection-product-price-${product.style_code}`}
                  {...globaleAttrs.display}
                >
                  {to_currency(product.selling, { precision: 0 })}
                </span>
                <span className="sr-only"> Original price: </span>
                <s className="text-grey-400 ml-6" {...globaleAttrs.reg}>
                  {to_currency(product.reg, { precision: 0 })}
                </s>
                {priceLineVariant && (
                  <span className="text-sale h-26 ml-6 border-l border-black px-6 uppercase">
                    {savePercent}% off
                  </span>
                )}
              </p>
            </>
          ) : (
            <p className="font-medium">
              <span className="sr-only">Current price: </span>
              <span className="text-12 tablet:text-13 widescreen:text-14">
                from
              </span>{" "}
              <span
                className="font-semibold"
                data-cy={`collection-product-price-${product.style_code}`}
                {...globaleAttrs.display}
              >
                {to_currency(product.reg, { precision: 0 })}
              </span>
            </p>
          )}
        </>
      ) : (
        <>
          <span className="sr-only">Current price: </span>
          <span
            className="text-emerald font-semibold uppercase"
            data-cy={`collection-product-price-${product.style_code}`}
          >
            {to_currency(product.selling, { precision: 0 })}
          </span>
        </>
      )}
    </div>
  )
}

ProductPrice.propTypes = {
  product: PropTypes.object,
}

export default ProductPrice
